// @docs https://[domain]/api/v1/docs
export default {
  List: "pyr/roles",
  ListShort: "pyr/roles/short",
  Detail: "pyr/roles",
  Create: "pyr/roles",
  Update: "pyr/roles",
  Delete: "pyr/roles",
};
